export const CLASS_CREATION_STATUSES = {
  pending: 'pending',
  failure: 'failure',
  success: 'success',
};

export const FINAL_CLASS_CREATION_STATUSES = [
  CLASS_CREATION_STATUSES.failure,
  CLASS_CREATION_STATUSES.success,
];
